"use strict";

(function(window) {

	Vue.component('member-cards', {

		props: {

			'lab': {
				type: Object
			},

			'pinRed': {
				type: String
			},

			'pinDark': {
				type: String
			}

		},

		template: `
			<div class="lab-card member-card">
			
				<div class="lab-card-header">
				
					<h3 class="h4 lab-name">
						<img v-if="lab.member" :src="pinRed" class="pin" />
						<img v-if="!lab.member" :src="pinDark" class="pin" />
						{{ decodeHtml(lab.name) }}
					</h3>
					
					<div class="address">
						<p><strong>Address:</strong> {{lab.addressParse[0]}}, {{lab.addressParse[1]}} {{lab.addressParse[2]}} {{lab.addressParse[3]}}</p>
					</div>
					
				</div>
					
					<div class="lab-card-content">
					
					<div class="content-table">
					
						<div class="content-table-header-row">
						
							<div class="content-table-col website">
								<h6>Website</h6>
							</div>
							
							<div class="content-table-col division">
								<h6>Division</h6>
							</div>
							
							<div class="content-table-col locations">
								<h6>Branch Locations</h6>
							</div>
							
						</div>
						
					</div>
					
					<div class="content-table-row">
		
						<div class="content-table-col website">
						
							<template v-if="lab.website">
							
								<div class="content-table-header-mobile website">
									<h6>Website</h6>
								</div>
								
								<p><a :href="formattedWebsite(lab.website)" target="_blank" style="word-break:break-all">{{ lab.website }}</a></p>
								
							</template>
						</div>
						
						<div class="content-table-col division">
							<template v-if="Object.keys(lab.divisions).length">
							
								<div class="content-table-header-mobile division">
									<h6>Division</h6>
								</div>
								
								<div v-for="division in lab.divisions">
									<span>{{ division }}</span>
								</div>
								
							</template>
						</div>
						
						<div class="content-table-col locations">
							<template v-if="Object.keys(lab.branches).length">
							
								<div class="content-table-header-mobile locations">
									<h6>Branch Locations</h6>
								</div>
							
								<div v-for="branch in lab.branches">
									<span>{{ branch }}</span>
								</div>
								
							</template>
						</div>
							
					</div>
					
				</div>
					
			</div>
		`,

		name: 'card',

		data () {
			return {

			}
		},

		mounted() {

		},

		methods: {
			replaceCategory (value) {
				if (!value) return value;

				if (value.search(/((Category)( |-)[0-2])/gi)) {
					return value.replace(/((Category)( |-)[0-2])/gi, 'Concrete');
				}

				return value;

			},
			decodeHtml(html) {
				const txt = document.createElement('textarea');
				txt.innerHTML = html;

				return txt.value;
			},
			formattedWebsite(url) {
				if (!url) return '';

				if (!/^https?:\/\//i.test(url)) {
					return 'https://' + url;
				}

				return url;
			}
		}

	});

})(window);
